import React from 'react';
import ManagerLink from '../../windowsManager/managerLink';

function Footer() {
  return (
    <ManagerLink />
  );
}

export default Footer;
